// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".campaign-image[data-v-aaaea852]{position:relative;display:block}.img-fluid[data-v-aaaea852]{display:block;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
